import createReactComponent from '../createReactComponent';
export default createReactComponent('markdown', 'IconMarkdown', [
  [
    'path',
    {
      d: 'M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M7 15v-6l2 2l2 -2v6', key: 'svg-1' }],
  ['path', { d: 'M14 13l2 2l2 -2m-2 2v-6', key: 'svg-2' }],
]);
